import { Link, Navigate, useParams } from 'react-router-dom';
import { FiArrowLeft, FiExternalLink } from 'react-icons/fi';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductIcon from '../components/ProductIcon';
import ProductScreenshots from '../components/ProductScreenshots';
import { getProductBySlug } from '../constants/products';

const ProductPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const product = getProductBySlug(slug);

  if (!product) {
    return <Navigate to="/products" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 max-w-5xl mx-auto px-4 sm:px-6 py-24 md:py-28 w-full">
        <Link
          to="/products"
          className="inline-flex items-center gap-2 text-sm text-brand-violet hover:text-slate-900 mb-10 transition-colors"
        >
          <FiArrowLeft aria-hidden />
          All apps
        </Link>

        <div className="flex flex-col sm:flex-row sm:items-start gap-8 mb-10">
          <ProductIcon name={product.name} src={product.iconSrc} size="lg" className="shrink-0" />
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">{product.category}</p>
            <h1 className="font-display text-4xl font-bold text-slate-900 mb-2">{product.name}</h1>
            <p className="text-lg text-brand-violet font-medium">{product.tagline}</p>
          </div>
        </div>

        <div className="mb-10">
          <ProductScreenshots productName={product.name} sources={product.screenshotSrcs} />
        </div>

        <p className="text-slate-600 leading-relaxed mb-8 max-w-3xl whitespace-pre-line">{product.summary}</p>

        <h2 className="text-lg font-semibold text-slate-900 mb-4">Highlights</h2>
        <ul className="list-disc pl-5 space-y-2 text-slate-600 mb-10 max-w-3xl">
          {product.highlights.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>

        <a
          href={product.appStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold bg-gradient-brand text-white shadow-brand hover:opacity-95 transition-opacity"
        >
          View on the App Store
          <FiExternalLink className="opacity-90" aria-hidden />
        </a>
      </main>
      <Footer />
    </div>
  );
};

export default ProductPage;
